module.exports = __webpack_public_path__ + "img/logo-sovalis.0771e586.svg";